import { createRoot } from 'react-dom/client';
import { MapWithHotspots } from '../../components/MapWithHotspots';

const pathParts = window.location.pathname.split('/');
const username = pathParts[2]; // /u/{username}/map

const container = document.getElementById('map-container');
if (container) {
    const root = createRoot(container);
    root.render(
        <MapWithHotspots hotspotsEndpoint={`/u/${username}/map/hotspots`} />
    );
}
